import { Link } from 'react-router-dom';
import './ContactPage.css';

function ContactPage() {
  return (
    <div className="ContactPage">
      <header className="contact-page-header">
        <div className="contact-page-header-inner">
          <img
            src="/images/logo_takahashi.png"
            alt="株式会社高橋機工"
            className="contact-page-logo"
          />
          <Link to="/" className="contact-page-back">
            トップへ戻る
          </Link>
        </div>
      </header>

      <section className="contact-page-hero">
        <div className="contact-page-hero-inner">
          <p className="contact-page-eyebrow">CONTACT</p>
          <h1 className="contact-page-title">お問い合わせ</h1>
          <p className="contact-page-lead">
            ご相談・ご依頼はお電話またはメールにて承っております。内容を確認のうえ、順次ご連絡いたします。
          </p>
        </div>
      </section>

      <main className="contact-page-main">
        <div className="contact-card-grid">
          <section className="contact-card">
            <p className="contact-card-label">お電話</p>
            <a className="contact-card-value" href="tel:0223678361">
              022-367-8361
            </a>
            <p className="contact-card-note">
              お急ぎのご相談はお電話がスムーズです。
            </p>
          </section>

          <section className="contact-card">
            <p className="contact-card-label">メール</p>
            <a className="contact-card-value" href="mailto:takahashikiko@aurora.ocn.ne.jp">
              takahashikiko@aurora.ocn.ne.jp
            </a>
            <p className="contact-card-note">
              図面・資料の共有がある場合はメールをご利用ください。
            </p>
          </section>
        </div>

        <section className="contact-info-panel">
          <div className="contact-info-row">
            <span className="contact-info-key">受付時間</span>
            <span className="contact-info-val">平日 8:00 - 17:00（目安）</span>
          </div>
          <div className="contact-info-row">
            <span className="contact-info-key">所在地</span>
            <span className="contact-info-val">宮城県塩竈市新浜町1丁目26-15</span>
          </div>
          <div className="contact-info-row">
            <span className="contact-info-key">ご案内</span>
            <span className="contact-info-val">
              内容確認後、担当者より折り返しご連絡いたします。
            </span>
          </div>
        </section>
      </main>

      <footer className="contact-page-footer">
        <p>Copyright© All Rights Reserved.</p>
      </footer>
    </div>
  );
}

export default ContactPage;
